export default (secs) => secs * 1000;
